import React from 'react';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import type { ConnectionState } from '../types';

interface Props {
  state: ConnectionState;
}

export default function ConnectionStatus({ state }: Props) {
  const { i18n } = useLingui();
  if (state === 'connected') return null;

  const config = {
    connecting: { text: msg`Connecting…`, className: 'conn-banner conn-connecting' },
    reconnecting: { text: msg`Connection lost. Reconnecting…`, className: 'conn-banner conn-reconnecting' },
    disconnected: { text: msg`Disconnected`, className: 'conn-banner conn-disconnected' },
  };

  const c = config[state];

  return (
    <div className={c.className}>
      <span className="conn-dot" />
      {i18n._(c.text)}
    </div>
  );
}
